<template>
  <v-container>
      
    <field-form @save="create" :saving="saving" @cancel="cancelWizard()" :wizard="true" :wizard-steps="currentWizard" :step="displayStep" button-icon="$add">
      <h2 class="text-h4 mb-3">{{$t('companies.add.title')}}</h2>
      <template v-slot:required>
      <v-autocomplete id="pfid1618854550" style="max-width:800px" prepend-icon="$country" :items="countries" v-model="country" :label="$t('companies.country')" />
      </template>
      <template v-slot:optional>
        <p>{{$t('companies.add.autofill')}}</p>
      <v-text-field id="pfid1618854554" 
      style="max-width:800px"
      prepend-icon="$crNo"
      :label="$t('companies.crNo')"
            v-model="crNo"
        ></v-text-field>
        <!--
        <v-switch label="The company is a VAT Payer" v-model="vatPayer" />
        -->
      </template>
    </field-form>
  </v-container>
</template>

<script>

  import {mapState} from 'vuex';
  import FieldForm from '@/components/FieldForm';
  import Countries from '@/mixins/countries';
  import Wizards from '@/mixins/wizards';
  
  export default {
    name: 'AddCompany',
    components: {FieldForm },
    mixins: [Countries, Wizards],
    data() {
      return {
        saving: false,
        country: 'CZ',
        crNo: null,
        vatPayer: false
      }
    },
    computed: {
      ...mapState('auth', ['user']),
      ...mapState('companies', ['prefill'])
    },
    methods: {
      create() {
        this.saving = true;
        let payload = { 
          country: this.country,
          crNo: this.crNo,
          //vatPayer: this.vatPayer,
          email: this.user.attributes.email,
          phone: this.user.attributes.phone_number,
        }
        payload = Object.assign(payload, this.prefill); 
        this.$store.dispatch('companies/create', payload).then((c) => { this.saving = false; console.debug('Company created', c); this.nextStep({ company: c.id }); })
      }
    },
    mounted() {
      this.$store.commit('ui/wizard', {value: true});
    },
  }
</script>
